import Text from '@cartwhl/ui/base/Text';

type TeamMemberProps = {
  name: string;
  position: string;
  image?: {
    src: string;
    alt: string;
  };
};

export default function TeamMember({ image, name, position }: TeamMemberProps) {
  return (
    <div className="px-10 pb-7 sm:px-0">
      {image ? (
        <img
          src={image.src}
          alt={image.alt}
          className="bg-gray-15 mx-auto block aspect-square rounded-xl object-contain"
        />
      ) : (
        <div className="bg-gray-15 block aspect-square w-full rounded-xl" />
      )}

      <Text
        as="div"
        variant="web/body/medium/lg"
        className="mx-auto mb-1 mt-3 lg:mt-6 xl:mt-8"
      >
        {name}
      </Text>
      <Text
        as="div"
        variant="web/body/medium/lg"
        className="text-gray-60 mx-auto"
      >
        {position}
      </Text>
    </div>
  );
}
